exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mgm-share-box{background:#fff;position:absolute;left:0;bottom:0;width:100%;height:240px;z-index:1}.mgm-share-box .mgm-share-item{height:56px;width:56px}.mgm-share-box .mgm-share-item>img{width:100%;height:100%}.mgm-share-box .mgm-share-box-title{height:40px;text-align:center;line-height:40px}.mgm-share-box .mgm-share-box-targets,.mgm-share-box .mgm-share-box-tools{padding-left:10px;height:100px;font-size:12px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-12295e58","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/utils/components/share.vue
// module id = 196
// module chunks = 93